export default {
  state: {
    importStatus: false
  },
  mutations: {
    SET_IMPORT_STATUS: (state) => {
      state.importStatus = !state.importStatus
    }
  },
  getters: {
    getterImportStatus: state => {
      return state.importStatus
    }
  }
}
